var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"id":`popover-header`}},[_c('font-awesome-icon',{class:[_vm.componentClass, _vm.currentRoute == '/ewa' ? 'ewa' : 'ok'],attrs:{"size":"lg","icon":_vm.thIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }